<template>
  <svg
    class="c-input__ico"
    :class="[classes ? classes : '']"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <use :xlink:href="'/assets/img/sprite.svg#'+icon" />
  </svg>
</template>

<script>
export default {
  props: {
    classes: { type: String, required: false },
    icon: String,
  },
}
</script>
